module.exports = __webpack_public_path__ + "static/media/排行榜_1.8035c9fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/TriennialsSpecial/HomeRankingModule/assets/images/排行榜_1.png
// module id = 428
// module chunks = 0